import styled from 'styled-components'

export const SearchButton = styled.button`
  position: absolute;
  right: 0.5em;
  top: 16%;
`
